module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("CHAPTER 2")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('h2', {
    staticClass: "h2sub"
  }, [_vm._v("SELF-CARE AND ASTROLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "chapimg"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/chap.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("A")]), _vm._v("strology is the study of the connection between the objects in the heavens (the planets, the stars) and what happens here on earth. Just as the movements of the planets and other heavenly bodies influence the ebb and flow of the tides, so do they influence you—your body, your mind, your spirit. This relationship is ever present and is never more important—or personal—than when viewed through the lens of self-care.")])]), _c('p', {
    staticClass: "indentx"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("In this chapter you’ll learn how the locations of these celestial bodies at the time of your birth affect you and define the self-care activities that will speak directly to you as a Leo, an Aries, a Capricorn, or any of the other zodiac signs. You’ll see how the zodiac influences every part of your being and why ignoring its lessons can leave you feeling frustrated and unfulfilled. You’ll also realize that, when you perform the rituals of self-care based on your sign, the wisdom of the cosmos will lead you down a path of fulfillment and restoration—to the return of who you really are, deep inside.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Zodiac Polarities")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In astrology, all signs are mirrored by other signs that are on the opposite side of the zodiac. This polarity ensures that the zodiac is balanced and continues to flow with an unbreakable, even stream of energy. There are two different polarities in the zodiac and each is called by a number of different names:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Yang/masculine/positive polarity")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Yin/feminine/negative polarity")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each polar opposite embodies a number of opposing traits, qualities, and attributes that will influence which self-care practices will work for or against your sign and your own personal sense of cosmic balance.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Yang")])])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Whether male or female, those who fall under yang, or masculine, signs are extroverted and radiate their energy outward. They are spontaneous, active, bold, and fearless. They move forward in life with the desire to enjoy everything the world has to offer to ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("them, and they work hard to transfer their inspiration and positivity to others so that those individuals may experience the same gifts that the universe offers them. All signs governed by the fire and air elements are yang and hold the potential for these dominant qualities. We will refer to them with masculine pronouns. These signs are:")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Aries")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Leo")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Sagittarius")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Gemini")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Libra")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Aquarius")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are people who hold yang energy who are introverted and retiring. However, by practicing self-care that is customized for your sign and understanding the potential ways to use your energy, you can find a way—perhaps one that’s unique to you—to claim your native buoyancy and dominance and engage with the path that the universe opens for you.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Yin")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Whether male or female, those who fall under yin, or feminine, signs are introverted and radiate inwardly. They draw people and experiences to them rather than seeking people and experiences in an extroverted way. They move forward in life with an energy that is reflective, receptive, and focused on communication and achieving shared goals. All signs governed by the earth and water elements are yin and hold the potential for these reflective qualities. We will refer to them with feminine pronouns. These signs are:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Taurus")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Virgo")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Capricorn")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Cancer")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Scorpio")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" Pisces")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("As there are people with yang energy who are introverted and retiring, there are also people with yin energy who are outgoing and extroverted. And by practicing self-care rituals that speak to your particular sign, energy, and governing body, you will reveal your true self and the balance of energy will be maintained.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Governing Elements")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Each astrological sign has a governing element that defines their energy orientation and influences both the way the sign moves through the universe and relates to self-care. The elements are fire, earth, air, and water. All the signs in each element share certain characteristics, along with having their own sign-specific qualities:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Fire:")]), _vm._v(" Fire signs are adventurous, bold, and energetic. They enjoy the heat and warm environments and look to the sun and fire as a means to recharge their depleted batteries. They’re competitive, outgoing, and passionate. The fire signs are Aries, Leo, and Sagittarius.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Earth:")]), _vm._v(" Earth signs all share a common love and tendency toward a practical, material, sensual, and economic orientation. The earth signs are Taurus, Virgo, and Capricorn.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Air:")]), _vm._v(" Air is the most ephemeral element and those born under this element are thinkers, innovators, and communicators. The air signs are Gemini, Libra, and Aquarius.")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Water:")]), _vm._v(" Water signs are instinctual, compassionate, sensitive, and emotional. The water signs are Cancer, Scorpio, and Pisces.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Chapter 3 teaches you all about the ways your specific governing element influences and drives your connection to your cosmically harmonious self-care rituals, but it’s important that you realize how important these elemental traits are to your self-care practice and to the activities that will help restore and reveal your true self.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Sign Qualities")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Each of the astrological elements governs three signs. Each of these three signs is also given its own quality or mode, which corresponds to a different part of each season: the beginning, the middle, or the end.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Cardinal signs:")]), _vm._v(" The cardinal signs initiate and lead in each season. Like something that is just starting out, they are actionable, enterprising, and assertive, and are born leaders. The cardinal signs are Aries, Cancer, Libra, and Capricorn.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Fixed signs:")]), _vm._v(" The fixed signs come into play when the season is well established. They are definite, consistent, reliable, motivated by principles, and powerfully stubborn. The fixed signs are Taurus, Leo, Scorpio, and Aquarius.")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Mutable signs:")]), _vm._v(" The mutable signs come to the forefront when the seasons are changing. They are part of one season, but also part of the next. They are adaptable, versatile, and flexible. The mutable signs are Gemini, Virgo, Sagittarius, and Pisces.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Each of these qualities tells you a lot about yourself and who you are. They also give you invaluable information about ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("the types of self-care rituals that your sign will find the most intuitive and helpful.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Ruling Planets")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In addition to qualities and elements, each specific sign is ruled by a particular planet that lends its personality to those born under that sign. Again, these sign-specific traits give you valuable insight into the personality of the signs and the self-care rituals that may best rejuvenate them. The signs that correspond to each planet—and the ways that those planetary influences determine your self-care options—are as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Aries:")]), _vm._v(" Ruled by Mars, Aries is passionate, energetic, and determined.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Taurus:")]), _vm._v(" Ruled by Venus, Taurus is sensual, romantic, and fertile.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Gemini:")]), _vm._v(" Ruled by Mercury, Gemini is intellectual, changeable, and talkative.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Cancer:")]), _vm._v(" Ruled by the Moon, Cancer is nostalgic, emotional, and home loving.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Leo:")]), _vm._v(" Ruled by the Sun, Leo is fiery, dramatic, and confident.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Virgo:")]), _vm._v(" Ruled by Mercury, Virgo is intellectual, analytical, and responsive.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Libra:")]), _vm._v(" Ruled by Venus, Libra is beautiful, romantic, and graceful.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Scorpio:")]), _vm._v(" Ruled by Mars and Pluto, Scorpio is intense, powerful, and magnetic.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Sagittarius:")]), _vm._v(" Ruled by Jupiter, Sagittarius is optimistic, boundless, and larger than life.")])]), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Capricorn:")]), _vm._v(" Ruled by Saturn, Capricorn is wise, patient, and disciplined.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Aquarius:")]), _vm._v(" Ruled by Uranus, Aquarius is independent, unique, and eccentric.")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/bull.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("Pisces:")]), _vm._v(" Ruled by Neptune and Jupiter, Pisces is dreamy, sympathetic, and idealistic.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("A Word on Sun Signs")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When someone is a Leo, Aries, Sagittarius, or any of the other zodiac signs, it means that the sun was positioned in this constellation in the heavens when they were born. Your Sun sign is a dominant factor in defining your personality, your best self-care practices, and your soul nature. Every person also has the position of the Moon, Mercury, Venus, Mars, Jupiter, Saturn, Uranus, Neptune, and Pluto. These planets can be in any of the elements: fire signs, earth signs, air signs, or water signs. If you have your entire chart calculated by an astrologer or on an Internet site, you can see the whole picture and learn about all your elements. Someone born under Leo with many signs in another element will not be as concentrated in the fire element as someone with five or six planets in Leo. Someone born in Pisces with many signs in another element will not be as concentrated in the water element as someone with five or six planets in Pisces. And so on. Astrology is a complex system and has many shades of meaning. For our purposes looking at the self-care practices designated by your Sun sign, or what most people consider "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("their")]), _vm._v(" sign, will give you the information you need to move forward and find fulfillment and restoration.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52b1801f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01_ch02.vue
// module id = 78
// module chunks = 0